/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SskSigningFailureReason {
    NO_SHARE = 'no_share',
    TIMEOUT = 'timeout',
    UNSUPPORTED_BROWSER = 'unsupported_browser',
    INVALID_TOKEN = 'invalid_token',
    UNKNOWN = 'unknown',
}
